<template>
  <a-layout>
    <Breadcrumb>
      <BreadcrumbItem> {{ pageTitle }} </BreadcrumbItem>
    </Breadcrumb>
    <a-alert
        v-if="sectionTwo.rationaleState==='已驳回' || sectionTwo.rationaleRiskState==='已驳回'"
        :message="mode==='risk-approve'?'风险评估驳回意见':'驳回意见'"
        :description="sectionTwo.auditOpinion"
        type="warning"
        show-icon
        style="margin: 10px 10px 0 20px;"
    />
    <div class="page-title-container">
      <span class="page-title">项目基本信息</span>
    </div>
    <div class="content-container">
      <div class="container">
        <div class="steps-content">

          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label required-field">电站性质</span>
            </div>
            <div class="field-content">
              <a-radio-group v-model="sectionTwo.usageAgreement" name="radioGroup">
                <a-radio value="全额上网">
                  全额上网
                </a-radio>
                <a-radio value="自发自用">
                  自发自用
                </a-radio>
              </a-radio-group>
              <div class="field-input-container">
                <span class="item-label">租赁年限：</span><a-input type="number"  v-model="sectionTwo.leaseStartYear" suffix="年" class="year-input" />
              </div>
              <div class="field-input-container">
                <span class="item-label">租金：</span><a-input type="number" v-model="sectionTwo.leasePrice" suffix="元 / m² · 年" class="year-input" />
              </div>
              <div class="field-input-container">
                <span class="item-label">EMC电价：</span><a-input type="number" v-model="sectionTwo.settlePrice" suffix="元 / kwh" class="year-input" />
              </div>
              <div class="field-input-container">
                <a-input placeholder="备注说明" v-model="sectionTwo.usageAgreementRemark" class="medium-input" />
              </div>
              <div v-if="sectionTwo.usageAgreement==='全额上网'" class="doc-uploader">
                <a-upload
                    name="file"
                    :multiple="false"
                    :action="uploadUrl"
                    :headers="headers"
                    :file-list="roofLeaseContract.docList"
                    @preview="onPreviewFile"
                    @change="onRoofLeaseContractChange"
                >
                  <a-button> <a-icon type="upload" /> 屋顶租赁协议 </a-button>
                </a-upload>
              </div>
              <div v-if="sectionTwo.usageAgreement==='自发自用'" class="doc-uploader">
                <a-upload
                    name="file"
                    :multiple="false"
                    :action="uploadUrl"
                    :headers="headers"
                    :file-list="energyContract.docList"
                    @preview="onPreviewFile"
                    @change="onEnergyContractChange"
                >
                  <a-button> <a-icon type="upload" /> 能源管理合同 </a-button>
                </a-upload>
              </div>
            </div>
          </div>

          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label required-field">房屋无大量灰尘，无易燃易爆物品、气体，防爆等级高于乙类厂房不可用</span>
            </div>
            <div class="field-content">
              <a-radio-group v-model="sectionTwo.explosiveRisk" name="radioGroup">
                <a-radio value="符合">
                  符合
                </a-radio>
                <a-radio value="不符合">
                  不符合
                </a-radio>
              </a-radio-group>
              <a-input placeholder="备注说明" v-model="sectionTwo.explosiveRiskRemark" class="remark-input" />
            </div>
          </div>

          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label required-field">生产过程中不产生腐蚀气体</span>
            </div>
            <div class="field-content">
              <a-radio-group v-model="sectionTwo.produceCorrosive" name="radioGroup">
                <a-radio value="符合">
                  符合
                </a-radio>
                <a-radio value="不符合">
                  不符合
                </a-radio>
              </a-radio-group>
              <a-input placeholder="备注说明" v-model="sectionTwo.produceCorrosiveRemark" class="remark-input" />
            </div>
          </div>

          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label required-field">钢结构房屋需为10年以内建筑，房屋无漏水，彩钢瓦无明显锈蚀；砖混结构厂房需为30年以内建筑</span>
            </div>
            <div class="field-content">
              <a-radio-group v-model="sectionTwo.leakingRisk" name="radioGroup">
                <a-radio value="符合">
                  符合
                </a-radio>
                <a-radio value="不符合">
                  不符合
                </a-radio>
              </a-radio-group>
              <a-input placeholder="备注说明" v-model="sectionTwo.leakingRiskRemark" class="remark-input" />
            </div>
          </div>

          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label required-field">砖墙结构房屋无明显墙体开裂、墙体倾斜现象</span>
            </div>
            <div class="field-content">
              <a-radio-group v-model="sectionTwo.collapseRisk" name="radioGroup" >
                <a-radio value="符合">
                  符合
                </a-radio>
                <a-radio value="不符合">
                  不符合
                </a-radio>
              </a-radio-group>
              <a-input placeholder="备注说明" v-model="sectionTwo.collapseRiskRemark" class="remark-input" />
            </div>
          </div>

          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label required-field">平屋顶需为混凝土浇筑屋面或厚度不小于80mm的混凝土预制板或厚度不低于80mm的双T板</span>
            </div>
            <div class="field-content">
              <a-radio-group v-model="sectionTwo.flatRoof" name="radioGroup">
                <a-radio value="符合">
                  符合
                </a-radio>
                <a-radio value="不符合">
                  不符合
                </a-radio>
              </a-radio-group>
              <a-input placeholder="备注说明" v-model="sectionTwo.flatRoofRemark" class="remark-input" />
            </div>
          </div>

          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label required-field">斜屋顶需为实铺平瓦屋面、钢筋混凝土挂瓦板平瓦屋面，且屋面结构简单无特殊造型</span>
            </div>
            <div class="field-content">
              <a-radio-group v-model="sectionTwo.slopeRoof" name="radioGroup">
                <a-radio value="符合">
                  符合
                </a-radio>
                <a-radio value="不符合">
                  不符合
                </a-radio>
              </a-radio-group>
              <a-input placeholder="备注说明" v-model="sectionTwo.slopeRoofRemark" class="remark-input" />
            </div>
          </div>

          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label required-field">屋顶应当无漏雨漏水现象、斜屋顶屋面瓦面破损率不大于15%，且光伏安装完成后屋面瓦面破损率为0</span>
            </div>
            <div class="field-content">
              <a-radio-group v-model="sectionTwo.breakage" name="radioGroup">
                <a-radio value="符合">
                  符合
                </a-radio>
                <a-radio value="不符合">
                  不符合
                </a-radio>
              </a-radio-group>
              <a-input placeholder="备注说明" v-model="sectionTwo.breakageRemark" class="remark-input" />
            </div>
          </div>

          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label required-field">屋面周围无外部遮挡</span>
            </div>
            <div class="field-content">
              <a-radio-group v-model="sectionTwo.blockage" name="radioGroup">
                <a-radio value="符合">
                  符合
                </a-radio>
                <a-radio value="不符合">
                  不符合
                </a-radio>
              </a-radio-group>
              <a-input placeholder="备注说明" v-model="sectionTwo.blockageRemark" class="remark-input" />
            </div>
          </div>

          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label required-field">若房屋或厂房在设计建设时已考虑加装光伏系统情况（以设计图纸为依据，由光伏设计人员核算并出具满足荷载的核算报告）外，其它房屋或厂房必须出具荷载报告</span>
            </div>
            <div class="field-content">
              <a-radio-group v-model="sectionTwo.solarConsidered" name="radioGroup">
                <a-radio value="符合">
                  符合
                </a-radio>
                <a-radio value="不符合">
                  不符合
                </a-radio>
              </a-radio-group>
              <a-input placeholder="备注说明" v-model="sectionTwo.solarConsideredRemark" class="remark-input" />
              <div v-if="sectionTwo.solarConsidered!=='不符合'" class="doc-uploader">
                <a-upload
                    name="file"
                    :multiple="false"
                    :action="uploadUrl"
                    :headers="headers"
                    :file-list="solarBlueprint.docList"
                    @preview="onPreviewFile"
                    @change="onSolarBlueprintUpload"
                >
                  <a-button> <a-icon type="upload" /> 厂区建筑结构 </a-button>
                </a-upload>
              </div>
            </div>
          </div>

          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label required-field">屋顶坡度大于10度时，北坡不可用</span>
            </div>
            <div class="field-content">
              <a-radio-group v-model="sectionTwo.slopeDegree" name="radioGroup" @change="toggleRemarkInput('breakage','breakageRemark')">
                <a-radio value="仅南坡">
                  仅南坡
                </a-radio>
                <a-radio value="南北双坡">
                  南北双坡
                </a-radio>
                <a-radio value="东西双坡">
                  东西双坡
                </a-radio>
              </a-radio-group>
              <a-input placeholder="备注说明" v-model="sectionTwo.slopeDegreeRemark" class="remark-input" />
            </div>
          </div>

          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label optional-field">厂房屋顶鸟瞰图、厂房内部天花板图、厂房内照片等房屋现状图</span>
            </div>
            <div class="field-content">
              <a-upload
                  name="file"
                  :multiple="false"
                  :action="uploadUrl"
                  :headers="headers"
                  :file-list="sitePhoto.docList"
                  @preview="onPreviewFile"
                  @change="onSitePhotoUpload"
              >
                <a-button> <a-icon type="upload" /> 上传附件 </a-button>
              </a-upload>
            </div>
          </div>

          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label optional-field">厂区变压器容量（多台变压器应分别描述）</span>
            </div>
            <div class="field-content">
              <a-input placeholder="例如：xxKVA+xxKVA等，共计xxKVA" v-model="sectionTwo.transformers" class="remark-input" />
            </div>
          </div>

          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label optional-field">厂区电气一次系统图（CAD版）</span>
            </div>
            <div class="field-content">
              <a-upload
                  name="file"
                  :multiple="false"
                  :action="uploadUrl"
                  :headers="headers"
                  :file-list="electricalDiagram.docList"
                  @preview="onPreviewFile"
                  @change="onElectricalDiagramUpload"
              >
                <a-button> <a-icon type="upload" /> 上传附件 </a-button>
              </a-upload>
            </div>
          </div>

          <div class="field-container">
            <div class="field-label-container">
              <span class="field-label optional-field">设计方案组件排布图</span>
            </div>
            <div class="field-content">
              <a-upload
                  name="file"
                  :multiple="false"
                  :action="uploadUrl"
                  :headers="headers"
                  :file-list="componentDiagram.docList"
                  @preview="onPreviewFile"
                  @change="onComponentDiagramUpload"
              >
                <a-button> <a-icon type="upload" /> 上传附件 </a-button>
              </a-upload>
            </div>
          </div>

        </div>
      </div>
    </div>
    <DocPreview ref="docPreview" />
  </a-layout>
</template>
<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import BreadcrumbItem from "@/components/BreadcrumbItem.vue";
import {baseURL} from "@/services/HttpService";
import {loadSectionTwo, saveSectionTwo} from "@/services/SpecService";
import DocPreview from "@/views/DocPreview.vue";

export default {
  props: {
    projectId: String,
    mode: String
  },
  emits: ['sectionSaved','saveSectionFailed'],
  components: { BreadcrumbItem, Breadcrumb, DocPreview },
  data() {
    return {
      pageTitle: "新增表单",
      current: 1,
      metricsGroupList: [
        {
          groupId: "group1",
          groupName: "项目底层企业信息"
        },
        {
          groupId: "group2",
          groupName: "项目基本信息"
        },
        {
          groupId: "group3",
          groupName: "前期手续"
        },
      ],
      headers: {
        authorization: 'authorization-text',
      },
      uploadUrl: baseURL + "/upload/spec",
      viewUrl: baseURL + "/attachment?fileName=",
      sectionTwo: {
        explosiveRisk: "",
        explosiveRiskRemark: "",
        produceCorrosive: "",
        produceCorrosiveRemark: "",
        leakingRisk: "",
        leakingRiskRemark: "",
        collapseRisk: "",
        collapseRiskRemark: "",
        flatRoof: "",
        flatRoofRemark: "",
        slopeRoof: "",
        slopeRoofRemark: "",
        breakage: "",
        breakageRemark: "",
        blockage: "",
        blockageRemark: "",
        solarConsidered: "",
        solarConsideredRemark: "",
        slopeDegree: "",
        slopeDegreeRemark: "",
        rationaleState: "",
        usageAgreement: "",
        leaseStartYear: "",
        leasePrice: "",
        settlePrice: "",
        editable: false,
        companyId: "",
        transformers:"",
        usageAgreementRemark: ""
      },


      roofLeaseContract: {
        loading: false,
        docList: [],
        title: "屋顶租赁合同"
      },
      energyContract: {
        loading: false,
        docList: [],
        title: "能源管理合同"
      },
      solarBlueprint: {
        loading: false,
        docList: [],
        title: "厂区建筑结构图"
      },
      sitePhoto: {
        loading: false,
        docList: [],
        title: "屋顶鸟瞰图"
      },
      electricalDiagram: {
        loading: false,
        docList: [],
        title: "厂区电气一次系统图"
      },
      componentDiagram: {
        loading: false,
        docList: [],
        title: "上传排布图"
      },


    };
  },
  created() {
    this.projectId = this.$route.params.id;
    this.mode = this.$route.params.mode;
    console.log('projectId', this.projectId);
    if(this.projectId!=='0') {
      this.pageTitle = "编辑表单";
    }
  },
  mounted() {
    this.startLoadSectionTwo();
  },
  methods: {
    getCompanyId(){
      return this.sectionTwo.companyId;
    },
    startLoadSectionTwo(){
      if(this.projectId!=="0") {
        loadSectionTwo(this.projectId).then(resp => {
          if (resp.data.code === "SUCCESS") {
            let data = resp.data.data;

            this.sectionTwo = data;

            this.buildDocList(data.solarBlueprintDocList, 'solarBlueprint');
            this.buildDocList(data.energyContractDocList, 'energyContract');
            this.buildDocList(data.roofLeaseContractDocList, 'roofLeaseContract');
            this.buildDocList(data.sitePhotoDocList, 'sitePhoto');
            this.buildDocList(data.electricalDiagramDocList, 'electricalDiagram');
            this.buildDocList(data.componentDiagramDocList, 'componentDiagram');
          }
        });
      }
    },
    buildDocList(docList, propName) {
      if(docList && docList.length > 0) {
        for (let i = 0; i < docList.length; i++) {
          let doc = docList[i];
          this[propName].docList.push({
            uid: doc.uid,
            name: doc.name,
            status: 'done',
            url: this.viewUrl + doc.url
          });
        }
      }
    },

    // 上传能源租赁合同
    onEnergyContractChange(info){
      let fileList = this.changeToAbsImgPath(info);
      this.energyContract.docList = fileList;
    },
    onRoofLeaseContractChange(info) {
      let fileList = this.changeToAbsImgPath(info);
      this.roofLeaseContract.docList = fileList;
    },
    onSolarBlueprintUpload(info) {
      let fileList = this.changeToAbsImgPath(info);
      this.solarBlueprint.docList = fileList;
    },
    onLandUsageOpinionDocUpload(info) {
      let fileList = this.changeToAbsImgPath(info);
      this.landUsageOpinion.docList = fileList;
    },
    onSitePhotoUpload(info) {
      let fileList = this.changeToAbsImgPath(info);
      this.sitePhoto.docList = fileList;
    },
    onElectricalDiagramUpload(info) {
      let fileList = this.changeToAbsImgPath(info);
      this.electricalDiagram.docList = fileList;
    },
    onComponentDiagramUpload(info) {
      let fileList = this.changeToAbsImgPath(info);
      this.componentDiagram.docList = fileList;
    },

    onRegistrationDocUpload(info) {
      let fileList = this.changeToAbsImgPath(info);
      this.registration.docList = fileList;
    },
    onEnvReviewDocChange(info) {
      let fileList = this.changeToAbsImgPath(info);
      this.envReview.docList = fileList;
    },
    changeToAbsImgPath(info){
      let fileList = [...info.fileList];

      fileList = fileList.map(file => {
        if (file.response) {
          file.url = this.viewUrl + file.response.data;
        }
        console.log('fileUrl', file.url);
        return file;
      });
      return fileList;
    },
    toggleRemarkInput(radioFieldName, remarkFieldName){
      if(this.sectionTwo[radioFieldName] === '符合') {
        this.sectionTwo[remarkFieldName] = '';
      }
    },

    prepareDocList(docList, params, propName){
      if(docList.length > 0) {
        for (let i = 0;i< docList.length; i++) {
          let oneDoc = docList[i];
          params[propName].push({
            uid: oneDoc.uid,
            name: oneDoc.name,
            url: oneDoc.url.replace(this.viewUrl, '')
          });
        }
      }
    },
    validateSectionTwo(isDraft){
      if(isDraft) {
        if(this.sectionTwo.leasePrice && isNaN(this.sectionTwo.leasePrice)) {
          return "租金必须是数字";
        }
        if(this.sectionTwo.leaseStartYear && isNaN(this.sectionTwo.leaseStartYear)) {
          return "租赁年限必须是数字";
        }
        return "";
      } else {
        let incompleteMsg = "请填写所有必填信息";
        if(!this.sectionTwo.explosiveRisk){
          return "请填写房屋无大量灰尘，无易燃易爆物品、气体，防爆等级高于乙类厂房不可用";
        }
        if(!this.sectionTwo.produceCorrosive){
          return "请填写生产过程中是否不产生腐蚀气体";
        }
        if(!this.sectionTwo.leakingRisk){
          return incompleteMsg;
        }
        if(!this.sectionTwo.collapseRisk){
          return incompleteMsg;
        }
        if(!this.sectionTwo.flatRoof){
          return incompleteMsg;
        }
        if(!this.sectionTwo.slopeRoof){
          return incompleteMsg;
        }
        if(!this.sectionTwo.breakage){
          return incompleteMsg;
        }
        if(!this.sectionTwo.blockage){
          return incompleteMsg;
        }
        if(!this.sectionTwo.solarConsidered){
          return incompleteMsg;
        }
        if(this.sectionTwo.solarConsidered==='已考虑' && this.solarBlueprint.docList.length === 0) {
          return "请上传设计图纸（组件排布图）";
        }
        if(!this.sectionTwo.slopeDegree){
          return incompleteMsg;
        }

        if(!this.sectionTwo.usageAgreement){
          return incompleteMsg;
        }
        if(!this.sectionTwo.leaseStartYear){
          return "请填写租赁年份";
        }
        if(this.sectionTwo.usageAgreement==='全额上网' && this.roofLeaseContract.docList.length === 0) {
          return "请上传屋顶租赁合同";
        }
        if(this.sectionTwo.usageAgreement==='自发自用' && this.energyContract.docList.length === 0) {
          return "请上传能源管理合同";
        }
        return "";
      }
    },
    onSaveDraft(){
      let isDraft = true;
      this.saveAs(isDraft);
    },
    onSubmit(auditorId) {
      let isDraft = false;
      this.saveAs(isDraft, auditorId);
    },
    saveAs(isDraft, auditorId){
      let validateMsg = this.validateSectionTwo(isDraft);
      console.log("validateMsg", ">"+validateMsg+"<");
      if(validateMsg==="") {
        auditorId = auditorId ? auditorId : "";
        let params = {
          ...this.sectionTwo,
          projectId: this.projectId,
          solarBlueprintDocList: [],
          energyContractDocList: [],
          roofLeaseContractDocList: [],
          sitePhotoDocList:[],
          electricalDiagramDocList: [],
          componentDiagramDocList: [],
          rationaleState: isDraft ? "未提交":"已提交",
          mode: this.mode,
          auditorId: auditorId
        }

        this.prepareDocList(this.solarBlueprint.docList, params, "solarBlueprintDocList");
        this.prepareDocList(this.energyContract.docList, params, "energyContractDocList");
        this.prepareDocList(this.roofLeaseContract.docList, params, "roofLeaseContractDocList");
        this.prepareDocList(this.sitePhoto.docList, params, "sitePhotoDocList");
        this.prepareDocList(this.electricalDiagram.docList, params, "electricalDiagramDocList");
        this.prepareDocList(this.componentDiagram.docList, params, "componentDiagramDocList");

        console.log("保存参数", params);
        saveSectionTwo(params).then(resp => {
          if (resp.data.code === "SUCCESS") {
            let projectId = resp.data.data;
            this.$emit('sectionSaved', projectId);
          } else {
            this.$message.error("操作失败: " + resp.data.errorMsg);
            this.$emit('saveSectionFailed');
          }
        });
      } else {
        this.$message.error(validateMsg);
        this.$emit('saveSectionFailed');
      }
    },
    showSectionTwo(){
      this.$router.push({
        path: "/adm/add-doc/" + this.projectId + "/" + this.mode
      });
    },
    onPreviewFile(doc){
      this.$refs.docPreview.previewFile(doc);
    },


  }
}
</script>
<style scoped>
.container {
  width: 100%;
  background-color: white;
  box-sizing: border-box;
  padding: 28px 32px;
  display: flex;
  flex-direction: column;
}
.long-input {
  max-width: 80%;
}
.medium-input {
  max-width: 60%;
}
.remark-input {
  max-width: 30%;
}
.field-container {
  padding-bottom: 12px;
}
.field-label-container {
  padding-top: 10px;
  padding-bottom: 10px;
  color: rgba(0, 0, 0, 0.85)
}
.field-label {
  margin-left: 4px;
}
.required-mark {
  color: red;
  margin-right: 2px;
}
.action-container {
  padding-top: 20px;
}
.draft-btn {
  margin-right: 30px;
}
.doc-uploader {
  margin-top: 12px;
}
.year-input {
  width: 160px;
}
.field-input-container {
  padding-top:10px;
  padding-bottom: 10px;
}
.del-btn {
  margin-top: 6px;
}
.item-label {
  display: inline-block;
  width: 7em;
}
</style>
